import { render, staticRenderFns } from "./Extraviolette.vue?vue&type=template&id=115bad20&scoped=true&"
import script from "./Extraviolette.vue?vue&type=script&lang=js&"
export * from "./Extraviolette.vue?vue&type=script&lang=js&"
import style0 from "./Extraviolette.vue?vue&type=style&index=0&id=115bad20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115bad20",
  null
  
)

export default component.exports